// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-container {
    padding: 20px;
    max-width: 1200px;
    margin: 0 auto;
}

.search-section {
    margin-bottom: 40px;
    padding: 20px;
    background: #f5f5f5;
    border-radius: 8px;
}

.search-box {
    display: flex;
    gap: 10px;
    margin-bottom: 20px;
}

.search-box input {
    flex: 1 1;
    padding: 8px;
    border: 1px solid #ddd;
    border-radius: 4px;
}

.search-box button {
    padding: 8px 16px;
    background: #007bff;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}

.user-info {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    margin-top: 20px;
    justify-content: flex-start;
}

.image-keyword-pair {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    min-width: 150px; /* Ensure enough space for image and text */
}

.user-image {
    width: 100px;
    height: 100px;
    border-radius: 8px;
    object-fit: cover;
}

.keyword-info {
    margin: 0;
    font-size: 14px;
    text-align: center;
}

.users-table {
    background: white;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;
}

th, td {
    padding: 12px;
    text-align: left;
    border-bottom: 1px solid #ddd;
}

th {
    background-color: #f8f9fa;
}

.table-image {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    object-fit: cover;
}

.loading {
    padding: 20px;
    text-align: center;
    color: #666;
}

.error-message {
    color: #dc3545;
    padding: 10px;
    background: #ffeef0;
    border-radius: 4px;
    margin: 10px 0;
}

/* Responsive design for smaller screens */
@media (max-width: 768px) {
    .user-info {
        flex-direction: column;
        align-items: center;
    }

    .image-keyword-pair {
        min-width: 120px;
    }

    .user-image {
        width: 80px;
        height: 80px;
    }

    .keyword-info {
        font-size: 12px;
    }
}

/* For very small screens */
@media (max-width: 480px) {
    .image-keyword-pair {
        min-width: 100px;
    }

    .user-image {
        width: 60px;
        height: 60px;
    }

    .keyword-info {
        font-size: 11px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/admin_page.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,gBAAgB,EAAE,2CAA2C;AACjE;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,qCAAqC;AACzC;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;AAClB;;AAEA,0CAA0C;AAC1C;IACI;QACI,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA,2BAA2B;AAC3B;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".admin-container {\n    padding: 20px;\n    max-width: 1200px;\n    margin: 0 auto;\n}\n\n.search-section {\n    margin-bottom: 40px;\n    padding: 20px;\n    background: #f5f5f5;\n    border-radius: 8px;\n}\n\n.search-box {\n    display: flex;\n    gap: 10px;\n    margin-bottom: 20px;\n}\n\n.search-box input {\n    flex: 1;\n    padding: 8px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n}\n\n.search-box button {\n    padding: 8px 16px;\n    background: #007bff;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n}\n\n.user-info {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 20px;\n    margin-top: 20px;\n    justify-content: flex-start;\n}\n\n.image-keyword-pair {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 10px;\n    min-width: 150px; /* Ensure enough space for image and text */\n}\n\n.user-image {\n    width: 100px;\n    height: 100px;\n    border-radius: 8px;\n    object-fit: cover;\n}\n\n.keyword-info {\n    margin: 0;\n    font-size: 14px;\n    text-align: center;\n}\n\n.users-table {\n    background: white;\n    padding: 20px;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\ntable {\n    width: 100%;\n    border-collapse: collapse;\n    margin-top: 20px;\n}\n\nth, td {\n    padding: 12px;\n    text-align: left;\n    border-bottom: 1px solid #ddd;\n}\n\nth {\n    background-color: #f8f9fa;\n}\n\n.table-image {\n    width: 50px;\n    height: 50px;\n    border-radius: 50%;\n    object-fit: cover;\n}\n\n.loading {\n    padding: 20px;\n    text-align: center;\n    color: #666;\n}\n\n.error-message {\n    color: #dc3545;\n    padding: 10px;\n    background: #ffeef0;\n    border-radius: 4px;\n    margin: 10px 0;\n}\n\n/* Responsive design for smaller screens */\n@media (max-width: 768px) {\n    .user-info {\n        flex-direction: column;\n        align-items: center;\n    }\n\n    .image-keyword-pair {\n        min-width: 120px;\n    }\n\n    .user-image {\n        width: 80px;\n        height: 80px;\n    }\n\n    .keyword-info {\n        font-size: 12px;\n    }\n}\n\n/* For very small screens */\n@media (max-width: 480px) {\n    .image-keyword-pair {\n        min-width: 100px;\n    }\n\n    .user-image {\n        width: 60px;\n        height: 60px;\n    }\n\n    .keyword-info {\n        font-size: 11px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
